import React, { useEffect, useMemo } from "react";
import SelectField from "../component/Partial/SelectField";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import TextField from "../component/Partial/TextField";
import Button from "../component/Partial/Button";
import { createRoom } from "../store/actions/projectAction";


function AddRooms() {
  const sections = useSelector((state) => state.project?.sections);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const params = useParams();
  const dispatch = useDispatch();

  const handleCreateRoomButtonClicked = ({ name, sectionId }) => {
    dispatch(
      createRoom({
        name: name,
        projectId: params?.id,
        sectionId: sectionId,
      })
    ).then(() => {
      setValue("name", "");
    })
  };

  const sectionsOptions = useMemo(() => {
    return sections?.map((item) => {
      return {
        label: item?.name,
        value: item?._id,
      };
    });
  }, [sections]);

  useEffect(() => {
    if (sectionsOptions?.length) {
      setValue("sectionId", sectionsOptions[0]?.value);
    }
  }, [sectionsOptions]);

  return (
    <div>
      <div className="text-2xl mb-2">
        <p>Add Room in your section</p>
      </div>
      <form
        className="flex gap-5"
        onSubmit={handleSubmit(handleCreateRoomButtonClicked)}
      >
        <SelectField
          options={sectionsOptions}
          placeholder="Select Section"
          register={register("sectionId", {
            required: "Section is required!",
          })}
        />

        <TextField
          placeholder="Room Name"
          register={register("name", {
            required: "Room is required!",
          })}
        />
        <Button text="Add" type="submit" className="px-14" />
      </form>
    </div>
  );
}

export default AddRooms;
